import { render } from "./IconChevron.vue?vue&type=template&id=6968cfd8&scoped=true&ts=true"
import script from "./IconChevron.vue?vue&type=script&lang=ts"
export * from "./IconChevron.vue?vue&type=script&lang=ts"

import "./IconChevron.vue?vue&type=style&index=0&id=6968cfd8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6968cfd8"]])

export default __exports__